

import { NgModule } from '@angular/core';
import { AuthModule } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

@NgModule({
    imports: [AuthModule.forRoot({
        config: {
            configId: environment.type,
            authority: GetConfig().identityUrl,
            authWellknownEndpointUrl: 'https://login.microsoftonline.com/047afd16-a725-4e2f-9260-fce3985944dc/v2.0',
            redirectUrl: "https://"+window.location.host+"/pbi-ui/",
            postLogoutRedirectUri: window.location.origin + "/pbi-ui/",
            forbiddenRoute: window.location.origin + '/forbidden',
            unauthorizedRoute: window.location.origin + '/unauthorized',
            clientId: GetConfig().clientId,
            scope: 'openid profile email offline_access',
            responseType: 'code',
            silentRenew: true,
            silentRenewUrl: window.location.origin + '/silent-renew.html',
            useRefreshToken: true,            
            ignoreNonceAfterRefresh: true,
            maxIdTokenIatOffsetAllowedInSeconds: 600,
            issValidationOff: false,
            autoUserInfo: false,
            allowUnsafeReuseRefreshToken: true,
            renewTimeBeforeTokenExpiresInSeconds: 30,
            logLevel: environment.authLogLevel,
            // secureRoutes: ['http://localhost:4200'],
            historyCleanupOff: false,
        }
    })],
    exports: [AuthModule],
})
export class AuthConfigModule { }


export function GetConfig() {
    const jsonFile =environment.filepath; //path to config file
    const request = new XMLHttpRequest();
    request.open('GET', jsonFile, false);  // get app settings
    request.send(null);
    const response = JSON.parse(request.responseText);
    return response;
  }
  